import IconArrowRight from '@apollo/icons/default/IconArrowRight.svg';
import moment from 'moment';
import React from 'react';
import { useLocation } from 'react-router';

import { insightsRouteConfig } from 'src/app/graph/routes';
import { useCursorUpdate } from 'src/components/charts/helpers/Cursor';
import { ConditionalLink } from 'src/components/conditionalLink/ConditionalLink';
import { LocalTimestamp } from 'src/components/timestamp/Timestamp';
import { format } from 'src/lib/format';
import { GraphQLTypes } from 'src/lib/graphqlTypes';
import { RouteConfig } from 'src/lib/routeConfig/RouteConfig';

export const ErrorInstance = ({
  queryId,
  queryName,
  traceId,
  traceStartsAt,
}: GraphQLTypes.Service_ErroredTraceSummariesQuery_service_stats_tracePathErrorsRefs_group) => {
  const onMouseMove = useCursorUpdate();
  const location = useLocation();

  return (
    <ConditionalLink
      className="group flex rounded text-sm hover:bg-secondary"
      onMouseEnter={() =>
        traceStartsAt && onMouseMove({ date: moment(traceStartsAt) })
      }
      onMouseLeave={() => onMouseMove(null)}
      to={
        traceId && queryId
          ? insightsRouteConfig.locationFrom({
              location,
              patch: {
                tab: 'traces',
                traceBucket: RouteConfig.DELETE,
                trace: traceId,
                query: queryId,
                queryName: queryName ?? RouteConfig.DELETE,
              },
            })
          : undefined
      }
    >
      <div className="ml-2 flex-2 truncate">
        {traceStartsAt && <LocalTimestamp value={traceStartsAt} />}
      </div>
      <div className="flex-4 truncate">
        <span className="mr-2 font-mono">{format.shortQueryId(queryId)}</span>
        {queryName || 'no operation name'}
      </div>
      <div className="flex-1 truncate font-mono">
        {(traceId || '').slice(-6)}
      </div>
      <IconArrowRight className="invisible mr-2 text-secondary group-hover:visible" />
    </ConditionalLink>
  );
};
